import {Component, Input, OnInit} from '@angular/core';
import {Artwork} from "../../models/artwork";
import {ArtworkService} from "../../services/artwork/artwork.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ArtworkModal} from "../../modals/artwork-modal/artwork-modal.component";
import {MessagesService} from "../../services/messages/messages.service";
import {Router} from "@angular/router";
import {merge} from "rxjs";

@Component({
  selector: 'app-artworks',
  templateUrl: './artworks.component.html',
  styleUrls: ['./artworks.component.scss']
})
export class ArtworksComponent implements OnInit {
  @Input() projectId: string;
  @Input() databaseId: string;
  @Input() code: string;

  artworks: Array<Artwork>;
  orderBy = 'code';

  constructor(
    private modalService: NgbModal,
    private artworkService: ArtworkService,
    private messagesService: MessagesService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    merge(
      this.artworkService.getAllMyArtworks(this.projectId, this.databaseId),
      this.artworkService.onChange
    )
      .subscribe(
        () => this.artworks = this.artworkService.artworks,
        err => console.error(err)
      );
  }

  onShowModal(artworkId?: string) {
    const modalRef = this.modalService.open(ArtworkModal, {size: 'lg'});

    modalRef.componentInstance.artworkId = artworkId;
    modalRef.componentInstance.projectId = this.projectId;
    modalRef.componentInstance.databaseId = this.databaseId;
  }

  onDelete(artworkId: string) {
    const modalRef = this.messagesService.confirmModal();

    modalRef.result
      .then(
        result => {
          if (result) {
            this.artworkService.deleteArtwork(this.projectId, this.databaseId, artworkId)
              .subscribe(
                () => {
                  this.messagesService.successToast('Artwork deleted.')
                  this.router.navigateByUrl('projects/' + this.projectId + '/databases/' + this.databaseId);
                },
                err => this.messagesService.errorToast(err)
              );
          }
        })
      .catch(() => {
      });
  }

  orderArtworks(orderBy) {
    this.artworkService.getAllMyArtworks(this.projectId, this.databaseId, orderBy)
      .subscribe(_ => this.artworks = this.artworkService.artworks);

    this.orderBy = orderBy;
  }
}
